import { ApolloError } from '@apollo/client';
import { ShopProductRecommendationFragment } from '../PaginatedRecommendations/getUngatedCategoryRecsPaginated';
import EmptyRecommendations from './EmptyRecommendations';
import LoadingRecommendations from './LoadingRecommendations';
import ShopProductCards from './ProductRecommendations/ShopProductCards';
const Recommendations = ({
  categoryId,
  categorySetId,
  shopProducts,
  loading,
  error
}: {
  categoryId: string;
  categorySetId: string;
  shopProducts?: ShopProductRecommendationFragment[] | null;
  loading: boolean;
  error?: ApolloError;
}) => {
  const hasShopProducts = shopProducts?.length && shopProducts.length > 0;
  const recommendations = hasShopProducts && <ShopProductCards categoryId={categoryId} categorySetId={categorySetId} shopProducts={shopProducts} />;
  const hasProductRecommendations = !!recommendations;

  // loading needs to come first so that we don't flash an error message before
  // we start loading content from the Graph
  if (loading) {
    return <LoadingRecommendations />;
  }
  // If an error occurred or there are no recommendations to display then render
  // empty recommendations message
  if (error || !hasProductRecommendations) {
    return <EmptyRecommendations categoryId={categoryId} />;
  }
  if (hasProductRecommendations) {
    return recommendations;
  }
  return null;
};
export default Recommendations;